import {
  MultiLineChart,
  SkeletonLoader,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${MultiLineChart.Styled.Plot} {
    height: 300px;
  }
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendItemVector = styled.div`
  height: 0;
  width: 16px;
  border-top: 1px solid var(--border-default);
`;

export const LegendItemLabel = styled.span`
  ${typographyV2.bodyBase};
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '240px',
        borderRadius: '8px',
      },
    },
  ],
})``;
